import React from 'react';

import { useIntl } from 'react-intl';

import ActionButton, { ActionButtonVariants } from 'components/action-button';
import SanityBlockRenderer from 'components/sanity-block-renderer';

import { StyledLink } from './loyalty-claim-points.styled';
import { useLoyaltyClaimPoints } from './use-loyalty-claim-points';

interface ILoyaltyClaimPointsLinkProps {
  className?: string;
  renderAsButton?: boolean;
}

const LoyaltyClaimPointsLink = ({
  className = '',
  renderAsButton,
}: ILoyaltyClaimPointsLinkProps) => {
  const { formatMessage } = useIntl();
  const { data } = useLoyaltyClaimPoints();

  const content = data?.claimOnHistory;
  const Wrapper = renderAsButton ? ActionButton : StyledLink;

  return content?.linkText ? (
    <Wrapper
      className={className}
      to={formatMessage({ id: 'routes.claimPointsBase' })}
      variant={renderAsButton ? ActionButtonVariants.OUTLINE : undefined}
    >
      <SanityBlockRenderer content={content.linkText.locale} />
    </Wrapper>
  ) : null;
};

export default LoyaltyClaimPointsLink;
